import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class QueueService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/queues', query);
  }

  listCalloutQueues(query?: any) {
    return this.get('/v2/calloutQueues', query);
  }

  create(body: any) {
    return this.post('/v2/queue', body);
  }

  find(id) {
    return this.get('/v2/queue/' + id);
  }

  update(id, body) {
    return this.put('/v2/queue/' + id, body);
  }

  allQueue(query?: any) {
    return this.get('/v2/all-queue', query);
  }

  _delete(id) {
    return this.delete('/v2/queue/' + id);
  }

  allQueueManager(query?: any) {
    return this.get('/v2/all-queue-manager', query);
  }

  allParam(query?: any) {
    return this.get('/v2/all-param', query);
  }

  addParam(queue_id, body) {
    return this.post('/v2/add-param/' + queue_id, body);
  }

  addAgent(queue_id, body) {
    return this.post('/v2/add-agent/' + queue_id, body);
  }
  addManyAgents(queue_id, body) {
    return this.post('/v2/add-many-agents/' + queue_id, body);
  }
  deleteManyAgents(queue_id, body) {
    return this.post('/v2/del-many-agents/' + queue_id, body);
  }

  deleteParam(queue_id, param_id) {
    return this.delete('/v2/del-param/' + queue_id + '/' + param_id);
  }
  deleteAgent(queue_id, agent_id) {
    return this.delete('/v2/del-agent/' + queue_id + '/' + agent_id);
  }

  agentInQueue(queue_id) {
    return this.get('/v2/agent-in-queue/' + queue_id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Queue.service.ts